"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubCrudRepository = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const Config_1 = require("../Config");
const fetch_utils_1 = require("../fetch.utils");
const observable_1 = require("../observable");
const GetByIdGrouped_1 = require("./groupGet/GetByIdGrouped");
const GetByIdGroupedLive_1 = require("./groupGet/GetByIdGroupedLive");
class SubCrudRepository {
    constructor(env, col, subCol) {
        this.env = env;
        this.col = col;
        this.subCol = subCol;
        /**
         * Returns entity in the sub collection
         * @param parent - Parrent entity id
         * @param uid - Entity id
         * @returns
         */
        this.getById = (parent, uid) => this.getByIdGrouped.get(uid, parent);
        this.getManyById = async (uids, parent) => {
            const params = {
                collection: this.col,
                parentUids: uids.map(() => parent),
                subCollection: this.subCol,
                uids,
            };
            return await (0, fetch_utils_1.wrappedFetch)((0, Config_1.getManyByIdUrl)(this.env), params);
        };
        /**
         * Returns entity in the sub collection as Observable
         * @param parent - Parrent entity id
         * @param uid - Entity id
         * @returns
         */
        this.getByIdLive = (parent, uid) => (0, rxjs_1.from)(this.getByIdGroupedLive.get(uid, parent)).pipe((0, rxjs_1.switchMap)((inner) => inner));
        this.getManyByIdLive = (uids, parent) => {
            const params = {
                collection: this.col,
                parentUids: uids.map(() => parent),
                subCollection: this.subCol,
                uids,
            };
            const url = (0, Config_1.getManyByIdUrl)(this.env) + (0, fetch_utils_1.toQueryParams)(params);
            return (0, observable_1.fetchLive)(this.env, url);
        };
        /**
         * Gets all documents paginated for the given sub collection
         * @param parent
         * @param startAfter
         * @returns
         */
        this.getAll = async (parent, startAfter) => {
            const params = { collection: this.col, uid: parent, subCollection: this.subCol, startAfter };
            return await (0, fetch_utils_1.wrappedFetch)((0, Config_1.getManyUrl)(this.env), params);
        };
        this.getAllLive = (parent, startAfter) => {
            const params = {
                collection: this.col,
                uid: parent,
                subCollection: this.subCol,
                startAfter,
                fieldName: [],
                fieldValue: [],
                operator: [],
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
        /**
         * Returns entities where the given field matches the given field value
         * @param parent
         * @param fieldName
         * @param fieldValue
         * @param startAfter
         * @returns
         */
        this.getByField = async (parent, fieldName, fieldValue, startAfter) => {
            const params = {
                collection: this.col,
                uid: parent,
                subCollection: this.subCol,
                fieldName,
                fieldValue,
                startAfter,
            };
            return await (0, fetch_utils_1.wrappedFetch)((0, Config_1.getManyUrl)(this.env), params);
        };
        /**
         * Returns entities updated after the given time
         * @param updatedAfter - Unix seconds
         * @returns
         */
        this.getAllUpdatedAfter = async (parent, updatedAfter) => {
            const params = { collection: this.col, uid: parent, subCollection: this.subCol, updatedAfter };
            return await (0, fetch_utils_1.wrappedFetch)((0, Config_1.getUpdatedAfterUrl)(this.env), params);
        };
        this.getTopBySubColIdLive = (uid, orderBy = ['createdOn'], orderByDir = ['desc'], startAfter, limit) => {
            const params = {
                collection: this.col,
                subCollection: this.subCol,
                fieldName: ['uid', 'parentCol'],
                fieldValue: [uid, this.col],
                operator: [interfaces_1.Opr.EQUAL, interfaces_1.Opr.EQUAL],
                startAfter,
                limit,
                orderBy,
                orderByDir,
            };
            return this.getManyAdvancedLive(params);
        };
        this.getManyAdvancedLive = (params) => {
            const url = (0, Config_1.getManyAdvancedUrl)(this.env) + (0, fetch_utils_1.toQueryParams)(Object.assign({}, params));
            return (0, observable_1.fetchLive)(this.env, url);
        };
        this.getByIdGroupedLive = new GetByIdGroupedLive_1.GetByIdGroupedLive(env, col, subCol);
        this.getByIdGrouped = new GetByIdGrouped_1.GetByIdGrouped(env, col, subCol);
    }
}
exports.SubCrudRepository = SubCrudRepository;
